import React, { useMemo } from 'react';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import {
  MarkdownH1,
  MarkdownH2,
  MarkdownH3,
  MarkdownLink,
  MarkdownTable,
  MarkdownTableCell,
  MarkdownTbody,
  MarkdownThead,
  MarkdownTr
} from '@/features/AIChat/AskGXDrawer/Messages/MarkdownComponents';
import { GX_REGEX } from '@/features/AIChat/AskGXDrawer/utils/gxCodes';
import type { AIMessage } from '@/features/AIChat/types/chat';
import WidgetMapper from '@/features/AIChat/widgets/WidgetMapper';

import type { Components } from 'react-markdown';

const AIContent = ({ msg }: { msg: AIMessage }) => {
  const markdownComponents: Components = useMemo(
    () => ({
      a: MarkdownLink,
      h1: MarkdownH1,
      h2: MarkdownH2,
      h3: MarkdownH3,
      table: MarkdownTable,
      thead: MarkdownThead,
      tbody: MarkdownTbody,
      tr: MarkdownTr,
      th: MarkdownTableCell,
      td: MarkdownTableCell
    }),
    []
  );

  return (
    <>
      {msg.content.map(part => {
        switch (part.kind) {
          case 'text':
            return (
              <ReactMarkdown
                key={part.text}
                components={markdownComponents}
                remarkPlugins={[remarkGfm]}
              >
                {part.text.replace(GX_REGEX, match => `[${match}](/${match})`)}
              </ReactMarkdown>
            );
          case 'tool_result':
            if (part.display === 'table') {
              return (
                <WidgetMapper
                  key={part.tool_call_id}
                  widgetData={part}
                />
              );
            }
            return null;
          default:
            return null;
        }
      })}
    </>
  );
};

export default AIContent;
